/**
 * Per-mailbox body snippet. Stored on the email account as `text_signature`,
 * inserted into generated mail as {{footer_text}}. Independent of the HTML
 * footer (images / branded block).
 *
 * Backend injects this into the template before the writer runs — same
 * moment as {{greeting}}. This helper is the shared replace.
 */

export const FOOTER_TEXT_RE = /\{\{\s*footer_text\s*\}\}/gi;

export const normalizeTextSignature = (value) =>
  String(value == null ? '' : value).replace(/\r\n/g, '\n');

export const accountTextSignature = (account) =>
  normalizeTextSignature(account?.text_signature);

export const applyFooterTextVariable = (text, signature) => {
  if (!text) return text || '';
  const value = normalizeTextSignature(signature);
  if (!value.trim()) {
    return String(text)
      .replace(FOOTER_TEXT_RE, '')
      .replace(/\n{3,}/g, '\n\n')
      .replace(/\s+$/, '');
  }
  return String(text).replace(FOOTER_TEXT_RE, () => value);
};
